const footerColumns = [
  {
    title: "快讯板块",
    links: [
      { label: "实时快报", href: "#live" },
      { label: "热门瓜榜", href: "#hot" },
      { label: "主题分类", href: "#topic" },
      { label: "深度专题", href: "#detail" },
    ],
  },
  {
    title: "了解我们",
    links: [
      { label: "关于瓜田速递", href: "#about" },
      { label: "编辑原则", href: "#about" },
      { label: "常见问题", href: "#faq" },
      { label: "联系方式", href: "#contact" },
    ],
  },
  {
    title: "使用与支持",
    links: [
      { label: "订阅快讯推送", href: "#contact" },
      { label: "内容纠错", href: "#contact" },
      { label: "合作与投稿", href: "#contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center font-heading text-xl leading-none">
                瓜
              </span>
              <span className="font-heading text-2xl text-background-50 tracking-wide">瓜田速递</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300 max-w-xs">
              把正在发生的动静按时间线提到最前面，24 小时滚动更新。不蹲群、不刷遍全网，也能第一时间接上正在发酵的瓜。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="#contact"
                aria-label="订阅快讯"
                className="w-9 h-9 rounded-md bg-background-800 text-background-100 flex items-center justify-center hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line text-lg" aria-hidden="true"></i>
              </a>
              <a
                href="#live"
                aria-label="查看实时快报"
                className="w-9 h-9 rounded-md bg-background-800 text-background-100 flex items-center justify-center hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-live-line text-lg" aria-hidden="true"></i>
              </a>
              <a
                href="#faq"
                aria-label="常见问题"
                className="w-9 h-9 rounded-md bg-background-800 text-background-100 flex items-center justify-center hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-question-line text-lg" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-base text-background-50 tracking-wide">{col.title}</h4>
              <ul className="mt-4 flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-700 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-background-400">
            © 2026 瓜田速递 · 站在时间线这一侧看热点
          </p>
          <p className="text-xs text-background-400 flex flex-wrap items-center gap-x-2 gap-y-1">
            <span>本站内容整理自公开渠道，仅供信息参考</span>
            <span className="text-background-600">·</span>
            <a href="#faq" className="hover:text-accent-400 transition-colors cursor-pointer">
              内容原则
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}